<template>
    <transition name="page-zoom" appear>
        <div v-if="image" class="lightbox">
            <img
                :src="$VUE_APP_API_URL + image.url"
                :alt="image.caption"
                class="lightbox__image img-fluid"
                @click="close()">
            <div v-if="image.caption" class="lightbox__caption">
                {{ image.caption }}
            </div>
            <div class="lightbox__close" @click="close()">
                <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" class="svg-inline--fa fa-times fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path></svg>
            </div>
        </div>
    </transition>
</template>

<script>  

export default {
    name: 'Lightbox',

    props: {
        image: {
            type: Object,
            default: null
        }
    },

    created() {
        document.body.classList.add('no-scroll')
    },

    mounted() {
        document.querySelector('.lightbox').parentElement.style.zIndex = 398
    },

    destroyed() {
        document.body.classList.remove('no-scroll')
        document.querySelector('.lightbox').parentElement.style.zIndex = 200
    },

    methods: {
        close() {
            this.$emit('update:image', null)
            this.$emit('closed')
        }
    }
}
</script>  